import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <div className="bg-green-800 text-white py-6 px-4">
        <div className="max-w-3xl mx-auto">
          <Link to="/sms-optin" className="inline-flex items-center text-green-100 hover:text-white mb-4">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back
          </Link>
          <h1 className="text-2xl font-bold">Terms of Service</h1>
          <p className="text-green-100">AV Realty Management</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-4 py-8 prose prose-slate">
        <p className="text-sm text-slate-500">Last Updated: March 2026</p>

        <h2>1. SMS Notification Service Terms</h2>
        <p>
          By opting in to receive SMS notifications from AV Realty Management, you agree to the following terms:
        </p>

        <h3>1.1 Consent</h3>
        <p>
          By providing your phone number and checking the consent box, you expressly consent to receive text messages 
          from AV Realty Management regarding:
        </p>
        <ul>
          <li>Rent payment reminders and confirmations</li>
          <li>Late payment notifications</li>
          <li>Maintenance and work order updates</li>
          <li>Lease renewal reminders</li>
          <li>Emergency property notifications</li>
          <li>Other property management communications</li>
        </ul>

        <h3>1.2 Message Frequency</h3>
        <p>
          Message frequency varies based on your account activity and property events. You may receive multiple 
          messages per month.
        </p>

        <h3>1.3 Costs</h3>
        <p>
          Message and data rates may apply. AV Realty Management does not charge for SMS messages, but your 
          mobile carrier may charge standard messaging rates.
        </p>

        <h3>1.4 Opt-Out</h3>
        <p>
          You can opt-out of SMS notifications at any time by:
        </p>
        <ul>
          <li>Replying STOP to any message</li>
          <li>Contacting us at (847) 962-0778</li>
          <li>Emailing contact@avrealtymgmt.com</li>
        </ul>
        <p>
          After opting out, you will receive a confirmation message. You will no longer receive SMS notifications 
          unless you opt-in again.
        </p>

        <h3>1.5 Help</h3>
        <p>
          For assistance with SMS notifications, reply HELP to any message or contact us directly.
        </p>

        <h2>2. General Terms</h2>
        
        <h3>2.1 Eligibility</h3>
        <p>
          You must be at least 18 years old and a current tenant, property owner, or authorized representative 
          to use our SMS notification service.
        </p>

        <h3>2.2 Accuracy of Information</h3>
        <p>
          You agree to provide accurate and current phone number information. You are responsible for updating 
          your contact information if it changes.
        </p>

        <h3>2.3 Limitation of Liability</h3>
        <p>
          AV Realty Management is not liable for any delays or failures in SMS delivery due to carrier issues, 
          network problems, or other factors outside our control.
        </p>

        <h2>3. Contact Information</h2>
        <p>
          <strong>AV Realty Management</strong><br />
          Phone: (847) 962-0778<br />
          Email: contact@avrealtymgmt.com
        </p>
      </div>
    </div>
  );
};

export default TermsOfService;
